import React, { FC, JSX } from 'react';
import { BadgeProps } from '../../types/components.d';

const Badge: FC<BadgeProps> = ({ 
  children, 
  variant = 'default', 
  size = 'md', 
  className = '',
  icon,
  iconPosition = 'left'
}): JSX.Element => {
  const variants: { [key: string]: string } = {
    default: 'bg-gray-100 text-gray-800',
    primary: 'bg-primary-lightGreen text-primary-black',
    secondary: 'bg-primary-teaGreen text-primary-black',
    success: 'bg-green-100 text-green-800',
    warning: 'bg-yellow-100 text-yellow-800',
    error: 'bg-red-100 text-red-800',
    info: 'bg-primary-lightGreen/20 text-primary-black',
    outline: 'border border-gray-300 text-gray-700 bg-transparent',
  };

  const sizes = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-2 text-base',
  };

  const baseClasses = 'inline-flex items-center font-medium rounded-full transition-colors duration-200';

  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`;

  const renderIcon = () => {
    if (!icon) return null;
    
    const iconSize = size === 'sm' ? 'w-3 h-3' : size === 'lg' ? 'w-5 h-5' : 'w-4 h-4';
    const marginClasses = iconPosition === 'left' ? 'mr-1' : 'ml-1';
    
    return (
      <span className={`${iconSize} ${marginClasses}`}>
        {icon}
      </span>
    );
  };

  return (
    <span className={classes}>
      {icon && iconPosition === 'left' && renderIcon()}
      {children}
      {icon && iconPosition === 'right' && renderIcon()}
    </span>
  );
};

export default Badge;
